var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "presentation__app", on: { mousemove: _vm.onMouseMove } },
    [
      _c(
        "div",
        {
          staticClass: "presentation__video-wrapper",
          class: _vm.isVideoFetched
            ? "presentation__video-wrapper_fetched"
            : "",
        },
        [
          _c(
            "video",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$mq === "mobile" || _vm.isInitedVideo,
                  expression: "$mq ==='mobile' || isInitedVideo",
                },
              ],
              ref: "video",
              staticClass: "presentation__video",
              domProps: { muted: _vm.isMuted },
              on: {
                timeupdate: _vm.onTimeUpdateListener,
                ended: function ($event) {
                  return _vm.onTimeEnd()
                },
              },
            },
            [_c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } })]
          ),
          _vm._v(" "),
          !_vm.isInitedVideo
            ? _c("div", {
                staticClass: "presentation__video-back",
                style: {
                  backgroundImage:
                    "url(" +
                    _vm.assetUrl(
                      "../img/video/" +
                        _vm.$t(
                          "presentationSlides." +
                            this.presentationId +
                            ".videoImg"
                        )
                    ) +
                    ")",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "presentation__video-info" }, [
            _c(
              "div",
              {
                staticClass: "presentation__video-info-play",
                on: { click: _vm.playerPlayToggle },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "36",
                      height: "36",
                      viewBox: "0 0 36 36",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
                        fill: "#00AD21",
                      },
                    }),
                    _vm._v(" "),
                    _vm.isPlaying
                      ? _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M24 24H12.0261V12H24V24Z",
                            fill: "white",
                          },
                        })
                      : _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M23.3333 18L14 24V12L23.3333 18Z",
                            fill: "white",
                          },
                        }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "presentation__video-info-name",
              domProps: {
                textContent: _vm._s(
                  _vm.$t(
                    "presentationSlides." + _vm.presentationId + ".personName"
                  )
                ),
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "presentation__video-info-position",
              domProps: {
                textContent: _vm._s(
                  _vm.$t(
                    "presentationSlides." +
                      _vm.presentationId +
                      ".personPosition"
                  )
                ),
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "presentation__content" }, [
          _c("div", { staticClass: "presentation__row" }, [
            _c("div", { staticClass: "presentation__content-left" }, [
              _c(
                "span",
                {
                  staticClass: "presentation__ply",
                  class: [
                    _vm.isPlaying
                      ? "presentation__ply_active"
                      : "presentation__ply_notactive",
                    !_vm.isMouseMoving && _vm.isPlaying
                      ? "presentation__ply_hidden"
                      : "",
                  ],
                  on: { click: _vm.playerPlayToggle },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "36",
                        height: "36",
                        viewBox: "0 0 36 36",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
                          fill: "#00AD21",
                        },
                      }),
                      _vm._v(" "),
                      _vm.isPlaying
                        ? _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M24 24H12.0261V12H24V24Z",
                              fill: "white",
                            },
                          })
                        : _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M23.3333 18L14 24V12L23.3333 18Z",
                              fill: "white",
                            },
                          }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", {
                staticClass: "presentation__video-info-name",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t(
                      "presentationSlides." + _vm.presentationId + ".personName"
                    )
                  ),
                },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "presentation__video-info-position",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t(
                      "presentationSlides." +
                        _vm.presentationId +
                        ".personPosition"
                    )
                  ),
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "presentation__content-right" }, [
              _c(
                "div",
                {
                  ref: "swiperContainer",
                  staticClass:
                    "swiper-container presentation__swiper-container",
                },
                [
                  _c("div", { staticClass: "presentation__controls" }, [
                    _c("div", { staticClass: "presentation__arrows" }, [
                      _c("div", {
                        staticClass:
                          "swiper-button-prev presentation__button-prev",
                        class: !_vm.canSwipeSlide(-1)
                          ? "presentation__button-prev_disabled"
                          : "",
                        domProps: {
                          innerHTML: _vm._s(require("../img/arrow-right.svg")),
                        },
                        on: { click: _vm.firePreviousSlide },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-button-next presentation__button-next",
                        class: !_vm.canSwipeSlide(1)
                          ? "presentation__button-next_disabled"
                          : "",
                        domProps: {
                          innerHTML: _vm._s(require("../img/arrow-right.svg")),
                        },
                        on: { click: _vm.fireNextSlide },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper presentation__wrapper" },
                    _vm._l(
                      _vm.$t(
                        "presentationSlides." + _vm.presentationId + ".slides"
                      ),
                      function (slide) {
                        return _c(
                          "div",
                          { staticClass: "swiper-slide presentation__slide" },
                          [
                            _c("div", {
                              staticClass: "presentation__slide-title",
                              domProps: { textContent: _vm._s(slide.title) },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "presentation__slide-text",
                              domProps: { innerHTML: _vm._s(slide.text) },
                            }),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "presentation__sound",
                  on: {
                    click: function ($event) {
                      _vm.isMuted = !_vm.isMuted
                    },
                  },
                },
                [
                  _vm.isMuted
                    ? _c("div", {
                        staticClass: "presentation__sound-item",
                        domProps: {
                          innerHTML: _vm._s(require("../img/volume_off.svg")),
                        },
                      })
                    : _c("div", {
                        staticClass:
                          "presentation__sound-item presentation__sound-item_enabled",
                        domProps: {
                          innerHTML: _vm._s(require("../img/volume_mute.svg")),
                        },
                      }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "presentation__links-wrapper" }, [
        _c("div", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "presentation__links" },
            _vm._l(
              _vm.$t("presentationSlides." + _vm.presentationId + ".slides"),
              function (slide, index) {
                return _c(
                  "div",
                  {
                    staticClass: "presentation__link",
                    class: _vm.videoMapData[index].isActive
                      ? "presentation__link_active"
                      : "",
                    on: {
                      click: function ($event) {
                        return _vm.onLinkItemClick(index)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "presentation__link-counter",
                      domProps: {
                        textContent: _vm._s(
                          (index + 1 < 10 ? "0" : "") + (index + 1) + "_"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "presentation__link-content" }, [
                      _c("div", {
                        staticClass: "presentation__link-title",
                        domProps: { textContent: _vm._s(slide.title) },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "presentation__link-arrow",
                        domProps: {
                          innerHTML: _vm._s(
                            require("../img/presentationArrow.svg")
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "presentation__timeline-wrapper" },
                      [
                        _c("div", { staticClass: "presentation__timeline" }, [
                          _c("div", {
                            staticClass: "presentation__timeline-line",
                            style: _vm.lineStyle(index),
                          }),
                        ]),
                      ]
                    ),
                  ]
                )
              }
            ),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }